<template>
  <el-dialog :title='dialogTitle' :visible.sync='dialogVisible' :close-on-click-modal='false'
             top='10vh' @close='dialogClose' width='1050px'>
    <el-form v-loading='formLoading' :model='form' label-width='140px' label-position='right'
             ref='ruleForm' class='p10 formHeight'>
      <div-border label='基础信息' class='p20'>
        <el-row :gutter='10'>
          <el-col :span='12'>
            <el-form-item label='变更编号：'>
              <span>{{ form.bgCode}}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='变更类型：'>
              <span>{{ form.bgType |typeFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='变更原因：'>
              <span>{{ form.reason}}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </div-border>
      <div-border label='委托车列表' class='p20'>
        <el-table
          v-if="this.form.bgType === 0"
          ref='searchTable'
          row-key='id'
          v-loading='tableLoading'
          :data='tableData'
          style='width: 100%'
          border
          sizi='mini'
          max-height='200'
          :header-cell-style='headerCellStyle'>
          <el-table-column label='批次号' prop='batchNumberY' align='center' width='140' />
          <el-table-column label='运单号' prop='waybillNoY' align='center' width='140' />
          <el-table-column label='车架号' prop='frameNumberY' align='center' width='180' />
          <el-table-column label='委托商' prop='consignorName' align='center' width='180' show-overflow-tooltip/>
          <el-table-column label='运输条款' prop='transRulesType' align='center' width='120' />
<!--          <el-table-column label='运输方式' prop='transportMode' align='center'-->
<!--                           :formatter='transportModeFormat' />-->
          <el-table-column label='提车场点' prop='pickCar' align='center' width='180' />
          <el-table-column label='起运地' prop='departurePlace' align='center' width='180' />
          <el-table-column label='起运港' prop='departurePort' align='center' width='180' />
          <el-table-column label='目的港' prop='arrivePort' align='center' width='180' />
          <el-table-column label='目的地' prop='arrivePlace' align='center' width='180' />
          <el-table-column label='收车单位(原经销商)' prop='collectCar' align='center' width='180' />
          <el-table-column label='品牌' prop='brandName' align='center' width='180' />
          <el-table-column label='型号' prop='modelName' align='center' width='180' />
          <el-table-column label='计划类型' prop='planTypeName' align='center' width='180' />
          <el-table-column label='计划时间 ' prop='planTime' align='center' width='180' />
          <el-table-column label='回单类型' prop='receiptType' align='center' width='180'
                           :formatter="receiptTypeFormat"/>
<!--          <el-table-column label='备注' prop='arrivePlace' align='center' width='180' />-->
          <el-table-column label='新批次号（批次号发生更改时填写' prop='batchNumber' align='center' width='180' />
          <el-table-column label='新运单号（运单号发生更改时填写）' prop='waybillNo' align='center' width='180' />
          <el-table-column label='新车架号（车架号发生更改时填写）' prop='frameNumber' align='center' width='180' />
        </el-table>
        <el-table
          v-else
          ref='searchTable'
          row-key='id'
          v-loading='tableLoading'
          :data='tableList'
          style='width: 100%'
          border
          sizi='mini'
          max-height='200'
          :header-cell-style='headerCellStyle'>
          <el-table-column label='批次号' prop='batchNumberY' align='center' width='140' />
          <el-table-column label='运单号' prop='billNumberY' align='center' width='140' />
          <el-table-column label='车架号' prop='frameNumberY' align='center' width='180' />
          <el-table-column label='变更路段' prop='changeLine' align='center' width='140'/>
<!--          <el-table-column label='运输方式(车或船舶)' prop='type' align='center' width='120'-->
<!--                           :formatter="typeFormat"/>-->
          <el-table-column label='装车时间' prop='loadingDate' align='center' width='120' show-overflow-tooltip/>
          <el-table-column label='交车时间' prop='deliveryDate' align='center' width='120' show-overflow-tooltip/>
          <el-table-column label='供应商类型' prop='supplierType' align='center' width='120'/>
          <el-table-column label='供应商' prop='supplierName' align='center' width='180' />
          <el-table-column label='装车地' prop='arrivePlace' align='center' width='120' />
          <el-table-column label='装车港口' prop='startName' align='center' width='120' />
          <el-table-column label='交车地' prop='arrivePlace' align='center' width='180' />
          <el-table-column label='交车港口' prop='arrivePlace' align='center' width='180' />
        </el-table>
        <el-pagination
          background
          :page-sizes='[10, 20, 30, 40]'
          layout='total, sizes, prev, pager, next, jumper'
          :total='total'
          size='mini'
          @size-change='detailSizeChange'
          @current-change='detailCurrentChange'
          :current-page.sync='searchForm.page'
          :page-size='searchForm.rows'
        />
      </div-border>
      <div-border label='操作记录' class='p20'>
        <el-table
          ref='registerTable'
          row-key='id'
          :data='form.operateRecordList'
          style='width: 100%'
          border
          :header-cell-style='headerCellStyle'
        >
          <el-table-column prop='createTime' label='操作时间' align='center' width='160px' />
          <el-table-column prop='operateType' label='操作类型' align='center' />
          <el-table-column prop='operationName' label='操作人' align='center' />
          <el-table-column prop='remark' label='备注' align='center' />
        </el-table>
      </div-border>
    </el-form>
  </el-dialog>
</template>

<script>
import divBorder from '@/components/divBorder.vue';
import {getDetail2} from "@/service/vehiclelog";

export default {
  name: 'supplierDeliveryInfo',
  components: { divBorder },
  data() {
    return {
      dialogTitle: '详情',
      dialogVisible: false,
      defaultForm: {},
      form: {},
      tableLoading: false,
      tableData: [],
      tableList: [],
      total: 0,
      headerCellStyle: {
        'color': '#3B3B3B',
        'font-size': '13px',
        'height': '48px',
        'background': '#E8E8E8',
      },
      formLoading: false,
      searchForm: {
        page: 1,
        rows: 10,
      },
      defaultSearchForm: {},
    };
  },
  filters: {
    typeFormat(value){
      switch (value) {
        case 0:
          return "运输计划变更";
        case 1:
          return "实际运输变更";
      }
    },
  },
  mounted() {
    this.defaultForm = JSON.parse(JSON.stringify(this.form));
    this.defaultSearchForm = JSON.parse(JSON.stringify(this.searchForm));
  },
  methods: {
    transportModeFormat(r, c, cellValue) {
      switch (cellValue) {
        case '1':
          return '公路';
        case '2':
          return '水路';
        case '3':
          return '水陆联运';
      }
    },
    typeFormat(r, c, cellValue) {
      switch (cellValue) {
        case 0:
          return '车';
        case 1:
          return '船舶';
      }
    },
    receiptTypeFormat(r, c, cellValue) {
      switch (cellValue) {
        case '1':
          return '电子回单';
        case '2':
          return '纸质回单';
      }
    },
    dialogOpen(row) {
      this.form.bgType = row.bgType
      this.form.bgCode = row.bgCode
      this.form.reason = row.reason
      this.dialogVisible = true;
      this.getDetailData(row.id);
    },
    // 查询
    searchBtn() {
      this.searchForm.page = 1;
      this.getDetailData();
    },
    //获取数据
    async getDetailData(id) {
      this.tableLoading = true;
      const {
        status,
        message,
        data,
      } = await getDetail2(id);
      this.tableLoading = false;
      if (status !== null) return this.$message.warning(message);
      if(this.form.bgType === 1){
        this.tableList = data.actualChangeList;
      }else {
        this.tableData = data.changePlanList;
      }
      this.form.operateRecordList = data.operateRecordList;
      this.total = data.total;
    },
    detailSizeChange(row) {
      this.searchForm.rows = row;
      this.searchForm.page = 1;
      this.getDetailData();
    },
    detailCurrentChange(page) {
      this.searchForm.page = page;
      this.getDetailData();
    },
    dialogClose() {
      this.dialogVisible = false;
    },
  }
};
</script>

<style lang='scss' scoped></style>
